import axios from 'axios'
import {UposlenikModel} from '../models/UposlenikModel'
import {getAuth} from '../modules/auth'
import {BojaModel, ParamsModelBoja} from "../models/BojaModel";
import {DigitalniDopFormValues, DigitalniDopItemValues} from "../models/DigitalniDopModel";
import {LaravelPaginationModel} from "../models/LaravelPaginationModel";

const API_URL = process.env.REACT_APP_API_URL

const auth: UposlenikModel = getAuth()!
const headers = {
    Accept: 'application/json',
    Authorization: auth?.access_token ?? '',
}

export async function getPanelDops(params: any) {
    return axios.get<LaravelPaginationModel<DigitalniDopFormValues>>(
        `${API_URL}/paneli/paneli-dop`,
        {headers, params}
    )
}

export async function getAllDopItems() {
    const response = await axios.get(`${API_URL}/paneli/get-dop-items`, {headers})
    return response.data
}

export async function saveDop(Data: any) {
    return await axios.post(`${API_URL}/paneli/paneli-dop`, Data, {headers: headers})
}

export async function fetchPanelDop(id: number) {
    try {
        const response = await axios.get(`${API_URL}/paneli/paneli-dop/${id}`)
        return response.data.data
    } catch (error: any) {
        console.error('Error fetching data:', error)
        throw error
    }
}

export async function updateDop(Id: number, Data: any) {

    try {

        const response = await axios.put(
            `${API_URL}/paneli/paneli-dop/${Id}`,
            Data,
            {headers}
        )

        return response.data

    } catch (error: any) {

        console.error('Error updating DOP:', error)

        throw error

    }

}

export async function getDopSifre(id: number) {
    try {
        const response = await axios.get(`${API_URL}/paneli/paneli-dop-sifre?dopId=${id}`)
        return response.data
    } catch (error: any) {
        console.error('Error fetching data:', error)
        throw error
    }
}

export async function deleteDopSifra(id: number) {
    try {
        const response = await axios.delete(`${API_URL}/paneli/paneli-dop-sifre`, {
            data: { id }
        })

        return response.data

    } catch (error: any) {
        console.error('Error deleting sifra:', error)
        throw error
    }
}

export async function validateSifra(sifra: string) {
    try {

        const response = await axios.get(`${API_URL}/paneli/validate-sifra/${encodeURIComponent(sifra)}`)

        return response.data

    } catch (error: any) {

        console.error('Error validating sifra:', error)
        throw error

    }
}

export async function saveDopSifra(Data: any) {
    return await axios.post(`${API_URL}/paneli/paneli-dop-sifre`, Data, {headers: headers})
}


export async function deleteDodjeljenuSifruDopu(Id: number) {
    try {
        const response = await axios.delete(
            `${API_URL}/paneli/paneli-dop-sifre/${Id}`,
            { headers }
        )

        if (response.data?.error === 0) {
            return response.data // ✅ return clean data
        }

        throw new Error(response.data?.message || 'Greška kod brisanja.')

    } catch (error: any) {
        console.error('Error deleting:', error)

        throw new Error(
            error?.response?.data?.message ||
            error?.message ||
            'Greška kod brisanja'
        )
    }
}

export async function getDostupniDopoviPoSifri(
    brojNaloga?: string | null,
    stavka?: string | null,
    sifra?: string | null
) {
    try {
        const params: any = {}

        // ✅ CASE 1: nalog
        if (brojNaloga) {
            params.brojNaloga = brojNaloga

            if (stavka) {
                params.stavka = stavka
            }
        }

        // ✅ CASE 2: sifra
        if (sifra) {
            params.sifra = sifra
        }

        const response = await axios.get(
            `${API_URL}/paneli/dostupni-dopovi-po-sifri`,
            { params }
        )

        return response.data
    } catch (error: any) {
        console.error('Error fetching dostupni dopovi:', error)
        throw error
    }
}

export async function getDostupniPrivremeniDopovi(
    brojNaloga: string,
    stavka?: string
) {
    try {
        const response = await axios.get(`${API_URL}/paneli/privremeni-dopovi-po-nalogu`, {
            params: {
                brojNaloga,
                ...(stavka && { stavka }) // 👈 optional
            }
        })

        return response.data
    } catch (error: any) {
        console.error('Error fetching privremeni dopovi:', error)
        throw error
    }
}

/**
 * GET LIST (with pagination, filters)
 */
export async function getPanelDopItems(params?: any) {
    return axios.get<LaravelPaginationModel<DigitalniDopItemValues>>(
        `${API_URL}/paneli/panel-dop-items`,
        {headers, params}
    )
}

/**
 * GET SINGLE
 */
export async function getPanelDopItem(id: number) {
    return axios.get<{success: boolean; data: DigitalniDopItemValues}>(
        `${API_URL}/paneli/panel-dop-items/${id}`,
        {headers}
    )
}

/**
 * CREATE
 */
export async function createPanelDopItem(data: DigitalniDopItemValues) {
    return axios.post<{success: boolean; data: DigitalniDopItemValues}>(
        `${API_URL}/paneli/panel-dop-items`,
        data,
        {headers}
    )
}

/**
 * UPDATE
 */
export async function updatePanelDopItem(
    id: number,
    data: Partial<DigitalniDopItemValues>
) {
    return axios.put<{success: boolean; data: DigitalniDopItemValues}>(
        `${API_URL}/paneli/panel-dop-items/${id}`,
        data,
        {headers}
    )
}

/**
 * DELETE
 */
export async function deletePanelDopItem(id: number) {
    return axios.delete<{success: boolean; message: string}>(
        `${API_URL}/paneli/panel-dop-items/${id}`,
        {headers}
    )
}

export async function saveDopWizzrd(Data: any) {
    return await axios.post(`${API_URL}/paneli/paneli-dop-wizard`, Data, {headers: headers})
}

export async function getPanelWizzardDops(params: any) {
    return axios.get<LaravelPaginationModel<DigitalniDopFormValues>>(
        `${API_URL}/paneli/paneli-dop-wizard/`,
        {headers, params}
    )
}

export async function fetchPanelWizzardDop(id: number) {
    try {
        const response = await axios.get(`${API_URL}/paneli/paneli-dop-wizard/${id}`)
        return response.data // ✅ FIXED
    } catch (error: any) {
        console.error('Error fetching data:', error)
        throw error
    }
}

export async function updateDopWizzard(Id: number, Data: any) {

    try {

        const response = await axios.put(
            `${API_URL}/paneli/paneli-dop-wizard/${Id}`,
            Data,
            {headers}
        )

        return response.data

    } catch (error: any) {

        console.error('Error updating DOP:', error)

        throw error

    }

}

export async function getDopDebljine(dopId: number) {
    try {
        const response = await axios.get(
            `${API_URL}/paneli/paneli-dop-debljine`,
            {
                headers,
                params: { dop_id: dopId }
            }
        )

        return response.data
    } catch (error: any) {
        console.error('Error fetching debljine:', error)
        throw error
    }
}